import { getHttpClient, unwrapContainer } from '@/api/client/http-client';
import type { NAInterfaceResponseObj } from '@/api/models';

export async function getTermsAndConditions(): Promise<string> {
  const client = getHttpClient();
  const response = await client.get<NAInterfaceResponseObj>('/Terms');
  return unwrapContainer<string>(response.data);
}

export async function acceptTermsAndConditions(
  accountUUID: string,
): Promise<NAInterfaceResponseObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Terms',
    { accountUUID, isAccepted: true },
  );
  return response.data;
}
